import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import FontKeys from '../FontKeys';
import SoundAssetKeys from '../SoundAssetKeys';
import SenseButton from './SenseButton';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Intro extends Phaser.Scene {
  static get KEY() { return 'Intro'; }

  create() {
    console.log('Intro');

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);
    this.snd = ABCyaPhaser.Audio.createSound(this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    this.sensesShown = 0;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'LandscapeMainBackground_4x3', this).setOrigin(0, 0);

    this.resizeContainer = this.add.container();

    this.circleOuter = ABCyaPhaser.Images.addImage(0, 0, 'CircleLine', this);
    this.circleOuter.x = this.mid.x;
    this.circleOuter.y = 768 / 2;
    this.circleOuter.alpha = 0;
    this.resizeContainer.add(this.circleOuter);

    this.circleInner = ABCyaPhaser.Images.addImage(0, 0, 'CircleYellow', this);
    this.circleInner.x = this.mid.x;
    this.circleInner.y = 768 / 2;
    this.circleInner.alpha = 0;
    this.resizeContainer.add(this.circleInner);

    const senselocs = [{ x: 512,y: 96 },{ x: 800,y: 324 },{ x: 683,y: 639 },{ x: 303,y: 596 },{ x: 241,y: 296 }];
    const charstypes = gameData.SENSES_CHARACTERS;// //;["Smell", "Sight", "Taste", "Hear", "Touch"];
    let item = null;
    this.senseButtons = [];
    for (let i = 0; i < charstypes.length; i++) {
      item = new SenseButton(this, charstypes[i].name, false);
      item.x = senselocs[i].x;
      item.y = senselocs[i].y;
      item.on('REVEAL_FINISHED', () => {this.showSense();});
      this.senseButtons.push(item);
      this.resizeContainer.add(item);
    }

    this.txtIntro = ABCyaPhaser.Text.addText(0, 0, 32, '0xFFFFFF', FontKeys._asapbold, ABCyaPhaser.Localization.instance.getLocalizedString('intro_text'), this, true).setWordWrapWidth(350);
    this.txtIntro.x = this.mid.x;
    this.txtIntro.y = this.scale.height / 2;
    this.resizeContainer.add(this.txtIntro);

    this.btnNext = ABCyaPhaser.Buttons.addSimpleButton(0, 0, 'BtnNext', null, () => {
      this.btnNext.setEnabled(false);
      this.goNext();
    }, this, { disabledTint: '0xFFFFFF' }).setOrigin(0, 0);
    this.btnNext.x = this.mid.x * 2 - this.btnNext.getBounds().width + 2;
    this.btnNext.y = this.mid.y * 2 - this.btnNext.getBounds().height - 15;

    this.layoutRatio();
    this.startIntro();
  }

  startIntro() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop2, this);

    this.circleInner.scaleX = 0;
    this.circleInner.scaleY = 0;
    this.circleInner.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.circleInner, 320, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out);

    this.txtIntro.scaleX = 0;
    this.txtIntro.scaleY = 0;
    this.txtIntro.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.txtIntro, 320, { delay: 200, scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Quadratic.Out, () => {
      this.startSound();
    });
  };

  startSound() {
    ABCyaPhaser.Audio.playSound(LocalizationSoundAssetKeys._We_have_five_senses, this.snd);
    this.snd.once('complete', () => {this.initShowSenses();});
  };

  initShowSenses() {
    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop2, this);

    this.circleOuter.scaleX = 0;
    this.circleOuter.scaleY = 0;
    this.circleOuter.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.circleOuter, 620, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Back.Out, () => {
      this.showSense();
    });
  };

  showSense() {
    if (this.sensesShown < this.senseButtons.length) {
      this.senseButtons[this.sensesShown].popin();
      this.sensesShown++;
    }
    else {
      console.log('INTRO FINISHED');
    }
  };

  goNext() {
    this.tweens.killAll();
    this.sound.stopAll();

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._click, this);

    this.scene.start('Slides');
  };

  layoutRatio() {
    this.resizeContainer.scaleX = 1.0;
    this.resizeContainer.scaleY = 1.0;
    this.resizeContainer.x = 0;
    this.resizeContainer.y = 0;
    this.btnNext.y = this.mid.y * 2 - this.btnNext.getBounds().height - 15;
  };
}